<div class="md-form md-outline bary-select">
  <mdb-select-2
    *ngIf="!withMdbIcons && options && options.length > 0"
    [outline]="true"
    [placeholder]="placeholder!"
    [dropdownClass]="'mdb-select-dropdown-colorful mdb-select-dropdown-primary'"
    [mdbValidate]="true"
    [validateSuccess]="false"
    [label]="label"
    [formControl]="control"
    [id]="id"
    data-mdb-filter="true"
    jhiMarkAsterisk
  >
    <mdb-select-filter *ngIf="hasFilter" data-id-cypress="mdb-select-filter" [formControl]="selectControlFilter"></mdb-select-filter>
    <mdb-select-option *ngFor="let option of options | optionFilter: selectControlFilter.value" [value]="option.value" [innerHTML]="option.label"></mdb-select-option>
  </mdb-select-2>

  <mdb-select-2
    *ngIf="withMdbIcons && optionsWithMdbIcons && optionsWithMdbIcons.length > 0"
    [outline]="true"
    [placeholder]="placeholder!"
    [dropdownClass]="'mdb-select-dropdown-colorful mdb-select-dropdown-primary'"
    [mdbValidate]="true"
    [validateSuccess]="false"
    [label]="label"
    [formControl]="control"
    [disabled]="disabled"
    [id]="id"
    jhiMarkAsterisk
  >
    <mdb-select-option *ngFor="let option of optionsWithMdbIcons" [value]="option.value">
      <jhi-bary-icon [icon]="option.mdbIcons" class="fa-fw"></jhi-bary-icon>
      {{ option.label }}
    </mdb-select-option>
  </mdb-select-2>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
  </mdb-error>
</div>
